import Image from "../image/Image.tsx";

const OrganisationLogo = ({
  src = "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/default_logo_organisation.png",
  isHuge = false,
  isLarge = false,
  isMedium = false,
  isSmall = false,
  additionalClasses = "",
}) => {
  let dimensions = "h-[55px] w-[55px]";

  let border =
    "border  border-color-border-tertiary dark:border-color-dark-border-tertiary border-opacity-50 ";

  if (isHuge) {
    dimensions = "h-20 w-20 md:h-28 md:w-28";
  }
  if (isLarge) {
    dimensions = "h-20 w-20";
  }
  if (isMedium) {
    dimensions = "h-[55px] w-[55px]";
  }
  if (isSmall) {
    dimensions = "h-[35px] w-[35px]";
  }

  return (
    <Image
      src={src}
      alt={"logo"}
      className={`rounded-md ${dimensions} ${additionalClasses} ${border}`}
    />
  );
};

export default OrganisationLogo;
